// extracted by mini-css-extract-plugin
export default {"spectrumButton":"PrimaryActionButton-module--spectrum-Button--2WASj","antBtn":"PrimaryActionButton-module--ant-btn--l8Wr5","button":"PrimaryActionButton-module--button--ilwhK"};